import { isProduction } from '@zapier/common-utils';

import { EVENT_TYPE } from './constants';

function emit(properties: Record<string, any>, type: EVENT_TYPE) {
  if (isProduction()) {
    emit(properties, type);
  } else {
    console.info(`🧭 Would have tracked /v4/event/ "${type}"`, properties);
  }
}

export { emit };
